import { useMemo, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { useFormikContext, Formik } from 'formik';

import styles from '@components/Order/Numbers/CheckoutNumbers/ProfilesForPlan.module.css';

import { BootstrapTable } from '@components/Table/Table';

const renderActionCell = ({ row }) => (
  <Button
    as={Link}
    to={`/profiles/edit/${row.values.id}`}
    variant="didxl"
    size="sm"
  >
    Update
  </Button>
);

const renderProfileNameHeader = ({ setFilterData }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  return (
    <Form.Group controlId="formGroupInvoiceID">
      <Form.Label>End user name</Form.Label>
      <Form.Control
        type="input"
        name="name"
        size="sm"
        value={values.name}
        onChange={(e) => {
          handleChange(e);
          setFilterData({ name: e.target.value });
        }}
        onBlur={handleBlur}
        placeholder="Search end user name"
      />
    </Form.Group>
  );
};

const ProfilesForPlan = ({ data }) => {
  const createColumn = (document) => ({
    id: document.id,
    Header: document.label,
    accessor: `documents.${document.id}`,
    className: 'col-md-1 text-center',
  });
  const [filterData, setFilterData] = useState({});
  const columns = useMemo(
    () => [
      {
        id: 'id',
        Header: '',
        accessor: 'id',
      },
      {
        id: 'appropriate',
        Header: '',
        accessor: 'appropriate',
      },
      {
        Header: () => renderProfileNameHeader({ setFilterData }),
        accessor: 'name',
        className: 'col-md-12',
      },
      ...data.fields.map((item) => createColumn(item)),
      {
        id: 'action',
        Header: '',
        Cell: renderActionCell,
        accessor: 'action',
      },
      {
        Header: 'Blocked',
        accessor: 'blocked',
        className: 'col-md-1 text-center',
      },
    ],
    []
  );

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        <Row>
          <Col>Available end users and required data + Documents</Col>
          <Col className="text-end">
            <Button as={Link} size="sm" variant="didxl" to="/profiles/new">
              Add end user
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Formik
          enableReinitialize
          initialValues={{ profileName: '' }}
          onSubmit={() => {}}
        >
          <div className={styles.tableContainer}>
            <BootstrapTable
              columns={columns}
              data={data.data}
              tableProps={() => ({
                bordered: true,
                className: 'normalFontSize',
              })}
              headerProps={() => ({
                className: 'align-top sticky-top bg-white',
              })}
              hiddenColumns={['id', 'appropriate']}
              rowProps={({ original }) =>
                original.valid && !original.blocked
                  ? {}
                  : { className: classNames('text-muted', 'bg-light') }
              }
              filterData={filterData}
            />
          </div>
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default ProfilesForPlan;
